module.exports = __webpack_public_path__ + "static/media/7032_9010.6e813999.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/7032_9010.jpg
// module id = 120
// module chunks = 0